// 금천아 빌려줘 — 수령·반납 방법 두 줄 (목록 카드 옵션 영역·상세 공용)
//
//   배송·회수 주문      → "배송·회수 O" / "직접 수령·반납 X"
//   직접 수령·반납 주문 → "배송·회수 X" / "직접 수령·반납 O"
//   판정 불가           → 두 줄 모두 "?"
//
// 판정은 서버(services/options.py resolve_fulfillment — 담당자 수동 지정 우선, 없으면
// 옵션 판정)가 하고 여기서는 그 값만 그린다.
// 색은 rental.css의 rental-fulfillment-row--on/off/unknown에서만 정한다 —
// 범보의자·테이블 줄(rental-opt--on/off)과 클래스를 나눠 서로 영향이 없게 했다.
import React from "react";

import { formatDateTime } from "./format";

const ROWS = [
  { key: "delivery", label: "배송·회수" },
  { key: "direct", label: "직접 수령·반납" },
];

// order를 넘기면 담당자 수동 변경 여부(fulfillment_manual)도 작게 표시한다.
export default function FulfillmentRows({ fulfillment, order = null }) {
  const unknown = fulfillment !== "delivery" && fulfillment !== "direct";
  const rows = ROWS.map((row) => {
    const state = unknown ? "unknown" : fulfillment === row.key ? "on" : "off";
    const mark = { on: "O", off: "X", unknown: "?" }[state];
    return (
      <li
        key={row.key}
        className={`rental-card-option rental-fulfillment-row rental-fulfillment-row--${state}`}
        data-option={`fulfillment-${row.key}`}
        title={
          unknown
            ? "수령·반납 방법 옵션 값으로 판정하지 못했습니다 — 주문 상세에서 확인하세요"
            : undefined
        }
      >
        <span className="rental-card-option-label">{row.label}</span>
        <span className="rental-opt-mark">{mark}</span>
      </li>
    );
  });
  if (order?.fulfillment_manual) {
    rows.push(
      <li
        key="manual"
        className="rental-fulfillment-manual"
        title={`${order.fulfillment_override_by_name || "-"} · ${formatDateTime(
          order.fulfillment_override_at
        )}`}
      >
        수동 변경
      </li>
    );
  }
  return rows;
}
